import { FC } from 'react';
import 'rc-collapse/assets/index.css';
import { Props } from './types';
import Panel from './Panel';
import { CollapseStyled } from './style';

interface I<T = unknown> extends FC<T> {
  Panel: typeof Panel;
}

const Collapse: I<Props> = ({ palette, ...rest }) => (
  <CollapseStyled
    // custom
    palette={palette}
    {...rest}
  />
);

Collapse.Panel = Panel;

export default Collapse;
